import { render, staticRenderFns } from "./DataOptionEdit.vue?vue&type=template&id=dfb33318&scoped=true&"
import script from "./DataOptionEdit.vue?vue&type=script&lang=js&"
export * from "./DataOptionEdit.vue?vue&type=script&lang=js&"
import style0 from "./DataOptionEdit.vue?vue&type=style&index=0&id=dfb33318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb33318",
  null
  
)

export default component.exports